import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { 
    MepPortSummaryTotalEmissionsRequest, 
    MepPortSummaryTotalEmissionsResponse, 
    MepPortSummaryVesselsByPortRequest, 
    MepPortSummaryVesselsByPortResponse,
    MepGetEmissionsByPortsRequest,
    MepGetEmissionsByPortsResponse,
    MepGetSummaryVesselStatisticsRequest,
    MepGetSummaryVesselStatisticsResponse,
    MepPortSummaryEmissionRequest,
    MepPortSummaryEmissionResponse
} from "../../models/mep/mep-summary.model";
import {Urls} from "../../constants/mep/mep-summary.constants";

@autoinject()
export class MepSummaryService {
    constructor(private requestClient: RequestClientService) {}

    public getMepPortSummaryTotalEmissions(request: MepPortSummaryTotalEmissionsRequest): Promise<MepPortSummaryTotalEmissionsResponse> {
        return this.requestClient.post<MepPortSummaryTotalEmissionsResponse>(`${Urls.GetMepPortSummaryTotalEmissions}`, {}, request);
    }

    public getMepEmissionsByPorts(request: MepGetEmissionsByPortsRequest) : Promise<MepGetEmissionsByPortsResponse> {
        return this.requestClient.post<MepGetEmissionsByPortsResponse>(`${Urls.GetMepEmissionsByPorts}`, {}, request);
    }

    public getMepPortSummaryVesselsByPort(request: MepPortSummaryVesselsByPortRequest): Promise<MepPortSummaryVesselsByPortResponse> {
        return this.requestClient.post<MepPortSummaryVesselsByPortResponse>(`${Urls.GetMepPortSummaryVesselsByPort}`, {}, request);
    }

    public getMepVesselStatisticsByCustomer(request: MepGetSummaryVesselStatisticsRequest): Promise<MepGetSummaryVesselStatisticsResponse> {
        return this.requestClient.post<MepGetSummaryVesselStatisticsResponse>(`${Urls.GetMepSummaryVesselStatistics}`, {}, request);
    }

    public getMepPortSummaryEmission(request: MepPortSummaryEmissionRequest): Promise<MepPortSummaryEmissionResponse> {
        return this.requestClient.post<MepPortSummaryEmissionResponse>(`${Urls.GetMepPortSummaryEmission}`, {}, request);
    }
}